import { GpRegion } from '~/plugins/grpc/universal/types';

export default (region: GpRegion | string) => {
  if (region === GpRegion.EUR) return 'EU';
  return region;
};
